export const priceIds: { [key: string]: { monthly: string; yearly: string; quarterly: string } } = {
    'hobby': {
      monthly: process.env.REACT_APP_STRIPE_HOBBY_MONTHLY_PRICE_ID || '',
      yearly: process.env.REACT_APP_STRIPE_HOBBY_ANNUAL_PRICE_ID || '',
      quarterly: process.env.REACT_APP_STRIPE_HOBBY_QUARTERLY_PRICE_ID || ''
    },
    'starter': {
      monthly: process.env.REACT_APP_STRIPE_STARTER_MONTHLY_PRICE_ID || '',
      yearly: process.env.REACT_APP_STRIPE_STARTER_ANNUAL_PRICE_ID || '',
      quarterly: process.env.REACT_APP_STRIPE_STARTER_QUARTERLY_PRICE_ID || ''
    },
    'expert': {
      monthly: process.env.REACT_APP_STRIPE_EXPERT_MONTHLY_PRICE_ID || '',
      yearly: process.env.REACT_APP_STRIPE_EXPERT_ANNUAL_PRICE_ID || '',
      quarterly: process.env.REACT_APP_STRIPE_EXPERT_QUARTERLY_PRICE_ID || ''
    }
  };